import { createRouter, createWebHistory } from "vue-router"
import Home from "@/views/Home.vue"

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/terms-of-services",
    name: "TermsServices",
    component: () => import(/* webpackChunkName: "termsservices" */ "@/views/TermsServices")
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
